import React from 'react';
import type { TFunction } from 'i18next';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetTeamDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { TKeys, useTranslation } from '../../../common/hooks/useTranslation';
import { teamName } from '../../../utils/teamName';

interface TeamsSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
}

export const teamForGrid = (
  t: TFunction<'administrationLng', 'administrationLng'>,
  tk: TKeys<'administrationLng'>,
  team: GetTeamDto,
) => {
  return {
    key: team.id,
    values: {
      'team.systemNumber': team.systemNumber,
      'team.name': teamName(team),
      'team.email': team.email,
      'employee.name': team.manager?.name,
      'company.shortname': team.company?.shortname,
      'pathPhase.value': team.pathPhase?.value,
      one_tool_team_label: team.oneToolTeam
        ? `[${team.oneToolTeam.oneToolId}] ${team.oneToolTeam.name}`
        : undefined,
      team_active_yes_no: team.active
        ? t(tk.common.yesUpperCase)
        : t(tk.common.noUpperCase),
    },
    isInactive: !team.active,
  };
};

export const TeamsSearch: React.FC<TeamsSearchProps> = props => {
  const { t, tk } = useTranslation('administrationLng');

  const columns: GridColumn[] = [
    { header: t(tk.common.sysNumber), property: 'team.systemNumber' },
    { header: t(tk.common.company), property: 'company.shortname' },
    { header: t(tk.common.name), property: 'team.name' },
    { header: t(tk.administration.email), property: 'team.email' },
    { header: t(tk.administration.managerName), property: 'employee.name' },
    { header: t(tk.administration.pathPhase), property: 'pathPhase.value' },
    {
      header: t(tk.administration.oneToolTeam),
      property: 'one_tool_team_label',
    },
    { header: t(tk.common.activeHe), property: 'team_active_yes_no' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="team.name"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.administration.noTeams)}
      onRowClick={props.onRowClick}
      refresh={props.refresh}
      withHistory={true}
      showExport={true}
      withFilterInColumns={true}
    />
  );
};
